import cloneDeep from "lodash/cloneDeep";

function application(state){
    return state.selected_application;
}

function auction(state) {
  return state.auction;
}

function application_id(state){
    return state.selected_application ? state.selected_application.loan.id : null;
}

function application_status(state){
    return state.application_status;
}

function security(state){
  let assetType = state.selected_application.loan.asset.type.toLowerCase();
  switch (assetType){
    case 'personal unsecured':
      return state.selected_application.loan.asset.unsecured;
    case 'personal secured':
      return state.selected_application.loan.asset.secured;
    default:
      return state.selected_application.loan.asset[assetType];
  }
}

const getApplication = (state) => () => {
    return state.selected_application;
}

const selected_pipeline_columns = (state) => () => {
  return state.selected_pipeline_columns
}

function work_basket(state){
    return state.work_basket;
}

function auction_basket(state) {
  return state.auction_basket;
}

function mql_auction_basket(state) {
  return state.mql_auction_basket;
}

function distribution_basket(state) {
  return state.distribution_basket;
}

function auction_lead_basket(state) {
  return state.auction_lead_basket;
}

function advance_search_application(state){
  return state.advance_search_application;
}

function application_search(state){
    return state.application_search;
}

function options(state){
    return state.types.options;
}

function properties(state) {
    return state.types.properties;
}

function docTemplates(state) {
    return state.doc_templates;
}

function documentTypes(state) {
    return state.document_types;
}

function documentRequests(state) {
    return state.document_requests;
}

function administration_permissions(state) {
    return state.administration_permissions;
}

function administration_roles(state) {
    return state.administration_roles;
}

let administrationRolesMatrix = (state) => () => {

    if(!state.administration_permissions || !state.administration_roles){
        return [];
    }

    let empty_permissions_map = Object.fromEntries(state.administration_permissions.map( p => [p, false]));

    return state.administration_roles.map( role => {

        let permissions = { ...empty_permissions_map };

        for(let permission of role.permissions){
            permissions[permission] = true;
        }

        return {
            name: role.name,
            permissions: permissions,
        };
    } );
}

let administrationUsers = (state) => () => {
    if(state.administration_users === null){
        return [];
    }else{
        return cloneDeep(state.administration_users);
    }
}

let administrationPods = (state) => () => {
    if(state.administration_pods === null){
        return [];
    }else{
        return cloneDeep(state.administration_pods);
    }
}

let administrationBrokers = (state) => () => {
    if (state.administration_brokers === null) {
        return [];
    } else {
        return cloneDeep(state.administration_brokers);
    }
}

let administrationBillings = (state) => () => {
    if (state.administration_billings === null) {
        return [];
    } else {
        return cloneDeep(state.administration_billings);
    }
}

let administrationIntroducers = (state) => () => {
  if (state.administration_introducers === null) {
    return [];
  } else {
    return cloneDeep(state.administration_introducers);
  }
}

let administrationGlassPrices = (state) => () => {
    if (state.administration_glass_prices === null) {
        return [];
    } else {
        return cloneDeep(state.administration_glass_prices);
    }
}

let administrationAdjustments = (state) => () => {
  if (state.administration_adjustments === null) {
    return [];
  } else {
    return cloneDeep(state.administration_adjustments);
  }
}

function user(state) {
    return state.user;
}

function introducers(state) {
  return state.introducers;
}

let userHasPermission = (state) => (name) => {
    if(state.user == null) return false;

    return state.user.permissions.includes(name);
}

let userHasRole = (state) => (name) => {
  if(state.user == null) return false;

  return state.user.primary_roles.includes(name);
}

let userHasAnyRole = (state) => (roles) => {
  if(state.user == null) return false;
  return roles.some(role => state.user.primary_roles.includes(role));
}

let userHasAppPermission = (state) => (name) => {
  if (!state.selected_application) return false;
  const permissions = state.selected_application.permissions;
  return permissions[name] ?? false
}

let product_types = (state) => {
    if(
        state.types &&
        state.types.options &&
        state.types.options.products_options
    ){
        return Object.keys(state.types.options.products_options);
    }else{
        return [];
    }
}
let productApplicantTypes = (state) => (product_type) => {
    if(
        state.types &&
        state.types.options &&
        state.types.options.products_options &&
        state.types.options.products_options[product_type]
    ){
        return Object.keys(state.types.options.products_options[product_type]);
    }else{
        return [];
    }

}
let productAssetTypes = (state) => (product_type, applicant_type) => {
    if(
        state.types &&
        state.types.options &&
        state.types.options.products_options &&
        state.types.options.products_options[product_type] &&
        state.types.options.products_options[product_type][applicant_type]
    ){
        return Object.keys(state.types.options.products_options[product_type][applicant_type]);
    }else{
        return [];
    }

}
let productLenders = (state) => (product_type, applicant_type, asset_type) => {
    if(
        state.types &&
        state.types.options &&
        state.types.options.products_options &&
        state.types.options.products_options[product_type] &&
        state.types.options.products_options[product_type][applicant_type] &&
        state.types.options.products_options[product_type][applicant_type][asset_type]
    ){
        return Object.keys(state.types.options.products_options[product_type][applicant_type][asset_type]);
    }else{
        return [];
    }

}
let products = (state) => (product_type, applicant_type, asset_type, product_lender) => {
    if(
        state.types &&
        state.types.options &&
        state.types.options.products_options &&
        state.types.options.products_options[product_type] &&
        state.types.options.products_options[product_type][applicant_type] &&
        state.types.options.products_options[product_type][applicant_type][asset_type] &&
        state.types.options.products_options[product_type][applicant_type][asset_type][product_lender]
    ){
        return state.types.options.products_options[product_type][applicant_type][asset_type][product_lender];
    }else{
        return [];
    }

}

function assessment(state) {
    return state.assessment;
}

function ml_assessment(state) {
  return state.ml_assessment;
}

function veda_report(state) {
  return state.veda_report;
}

function broker_postcode(state) {
  return state.broker_postcode;
}

function broker_radius(state) {
  return state.broker_radius;
}

function agent_has_visibility_subscription(state) {
  return state.agent_has_visibility_subscription
}

function cut_off_day(state) {
  return state.cut_off_day
}

function is_ram_authorized(state) {
  return state.is_ram_authorized;
}

function auditLogs(state){
    return state.audit_logs;
}

function updating_application(state) {
  return state.updating_application
}

/**
 * @param {Object} state
 * @param state
 * @returns {null|*}
 */
function preGraphData(state){
  return state.pre_graph_data;
}

/**
 * @param {Object} state
 * @returns {null|*}
 */
function activeAppsGraphData(state){
  return state.active_apps_graph_data;
}

function lenders_breakdown(state){
  return state.administration_lenders_breakdown;
}

function leadRequests(state){
  return state.lead_requests;
}

function isPodManager(state){
  return state.isPodManager;
}

function show_live_auction_drawer(state) {
  return state.show_live_auction_drawer;
}

function live_auction_previews(state) {
  return state.live_auction_previews;
}

/**
 * @param {Object} state
 * @param state
 * @returns {null|*}
 */
function reportingMetaDataAppBased(state) {
  return state.reporting_meta_date_app_based;
}

/**
 * @param {Object} state
 * @param state
 * @returns {null|*}
 */
function reportingMetaDataSettlementBased(state) {
  return state.reporting_meta_date_settlement_based;
}

/**
 * load data from ppsrSearch database
 *
 * @param state
 * @returns {{}|*}
 */
function ppsrFetchResults(state) {
    return state.ppsr_search_results;
}

/**
 * load data by Equifax API call
 *
 * @param state
 * @returns {{}|*}
 */
function ppsrSearchResults(state) {
  return state.ppsr_search_results;
}

/**
 * search by Equifax Vin API call
 *
 * @param state
 * @returns {string|*}
 */
function getPpsrVinValue(state) {
  if (state.ppsr_search_results &&
    state.ppsr_search_results.ppsr_search_details &&
        state.ppsr_search_results.ppsr_search_details.VIN &&
        state.ppsr_search_results.ppsr_search_details.VIN.length > 0) {
        return state.ppsr_search_results.ppsr_search_details.VIN;
  }

  return '';
}

/**
 * search by Equifax Registration API call
 * the request_value is {"reg": "******", "state": "***"}
 *
 * @param state
 * @returns {string|*}
 */
function getPpsrRegistrationValue(state) {
  if (state.ppsr_search_results &&
    state.ppsr_search_results.request_value) {
    return state.ppsr_search_results.request_value;
  }

  return '';
}
function getLeadRequestsForecasts(state) {
  return state.lead_requests_forecasts;
}

function getPpsrStatus(state) {
  if (state.ppsr_status_result) {
    return state.ppsr_status_result;
  }

  return '';
}

let getBillings = (state) => () => {
  if (state.billings === null) {
    return [];
  } else {
    return cloneDeep(state.billings);
  }
}

let getSelectedBills = (state) => () => {
  if(state.selected_bills === null) {
    return [];
  } else {
    return state.selected_bills;
  }
}

const warranty_billings = (state) => {
  if (state.warranty_billings === null) {
    return [];
  } else {
    return cloneDeep(state.warranty_billings);
  }
}

function application_update_status_dialog(state) {
    return state.application_update_status_dialog;
}
function application_update_owners_dialog(state) {
    return state.application_update_owners_dialog;
}
function application_comment_dialog(state) {
    return state.application_comment_dialog;
}
function veda_summary_dialog(state) {
    return state.veda_summary_dialog;
}
function application_quick_response_dialog(state) {
  return state.application_quick_response_dialog;
}
function employment_directorship_dialog(state) {
  return state.employment_directorship_dialog;
}

function edit_user_profile_dialog(state) {
  return state.edit_user_profile_dialog;
}

function application_referrer(state) {
    return state.application_referrer;
}

function requires_current_privacy_consent(state) {
  const applicants = state.selected_application?.applicants || [];
     return applicants.some(applicant => 
      applicant.privacy_consent?.consent_type === "Not Given"
    );
}

function requires_previous_privacy_consent(state) {
  const applicants = state.selected_application?.applicants || [];
     return applicants.some(applicant => 
      applicant.previous_privacy_consent?.consent_type === "Not Given"
    );
}

function uploadedDocuments(state) {
  return state.uploadedDocuments;
}

/**
 * load data from Land title search database call
 *
 * @param state
 * @returns {{}|*}
 */
function landTitleFetchResults(state) {
  return state.land_title_search_results;
}

function makers(state) {
  return state.makers;
}

function all_makers(state) {
  return state.all_makers;
}

function models(state) {
  return state.models;
}

function models_make(state) {
  return state.models_make;
}

function glasses(state) {
  return state.glasses;
}

/**
 * setup bank statement types
 * use description in document_types table
 */
const bankStatementTypes = ["Bank/MyGov Statement", "3 Months Bank Statements (Link)", "6 Months Bank Statements (Link)"];

/**
 * get documents without the bank statements
 *
 * @param state
 * @returns array
 */
function uploadedDocumentsWithoutBankStatement(state) {

  if (state.uploadedDocuments == null) {
    return [];
  }

  let uploadDocs = state.uploadedDocuments;
  return uploadDocs.filter((uploadDoc) => !bankStatementTypes.includes(uploadDoc.document_type) && (uploadDoc.deleted_at == null) && (uploadDoc.doc_template_id == null) && (uploadDoc.from_docusign_env_id == null));
}

/**
 * get documents bank statements only
 *
 * @param state
 * @returns array
 */
function uploadedDocumentsBankStatement(state) {

  if (state.uploadedDocuments == null) {
    return [];
  }

  let uploadDocs = state.uploadedDocuments;
  //return uploaddocs which is included in bankstatementtypes and deleted_at is null
  return uploadDocs.filter((uploadDoc) => bankStatementTypes.includes(uploadDoc.document_type) && (uploadDoc.deleted_at == null));
}

function uploadedDocsWithTypeOther(state) {
  if (state.uploadedDocuments == null) {
      return [];
    }

  let uploadDocs = state.uploadedDocuments;
  return uploadDocs.filter((uploadDoc) => uploadDoc.document_type == "Other" && (uploadDoc.deleted_at == null));
}

/**
 * get documents deleted
 *
 * @param state
 * @returns array
 */
function deletedDocuments(state) {

  if (state.uploadedDocuments == null) {
    return [];
  }

  let uploadDocs = state.uploadedDocuments;
  return uploadDocs.filter((uploadDoc) => uploadDoc.deleted_at != null);
}

/**
 * get Signed documents
 *
 * @param state
 * @returns array
 */
 function signedDocuments(state) {

  if (state.uploadedDocuments == null) {
    return [];
  }

  let uploadDocs = state.uploadedDocuments;
  return uploadDocs.filter((uploadDoc) => (uploadDoc.from_docusign_env_id != null && uploadDoc.docusign_envelope_id == null) && (uploadDoc.deleted_at == null));
}


/**
 * get generated documents from template
 *
 * @param state
 * @returns array
 */

function generatedDocuments(state) {
  if (state.uploadedDocuments == null) {
    return [];
  }

  let uploadDocs = state.uploadedDocuments;
  return uploadDocs.filter((uploadDoc) => uploadDoc.doc_template_id != null && (uploadDoc.deleted_at == null) && (uploadDoc.from_docusign_env_id == null));
}

/**
 * @desc checks whether the submit to lender form is open or not.
 * @param state
 * @returns boolean
 */
function toggleSubmitToLenderForm(state){
  return state.toggleSubmitToLenderForm;
}

/**
 * return error fields in capture
 * @param state
 * @returns array
 */
function error_fields(state) {
  return state.error_fields;
}

function current_lock(state) {
  return state.current_lock;
}

function is_editing(state) {
  return state.is_editing;
}

function appLockConfig(state) {
    return state.application_lock;
}

let administrationAgents = (state) => {
  if (state.administration_agents === null) {
      return [];
  } else {
      return cloneDeep(state.administration_agents);
  }
}

let allTypesAgents = (state) => {
  if (state.all_types_agents === null) {
      return [];
  } else {
      return cloneDeep(state.all_types_agents);
  }
}

let applicationLocks = (state) => () => {
    if (state.application_locks === null) {
        return [];
    } else {
        return cloneDeep(state.application_locks);
    }
}

let getApplicationNextActionData = (state) => (id) => {
  if (state.nextActionDateData && state.nextActionDateData[id]) {
    return state.nextActionDateData[id];
  }
};

function getAllApplicationsNextActionData(state) {
  return state.nextActionDateData;
}

function call_outcome_logs(state) {
  return state.call_outcome_logs;
}

/**
 * get auction notification
 * @param {object} state
 * @returns array
 */
function get_auction_notification(state) {
  return state.auction_notification;
}

/**
 * Get last auction notification timestamp
 * @param {object} state
 * @returns number
 */
function get_last_auction_notification_timestamp(state) {
  return state.last_auction_notification_timestamp;
}

function pagination(state){
  return state.pagination;
}

function get_hem_living_expense_access(state) {
  return state.hem_living_expense_access;
}

function get_hem_living_expense(state) {
  return state.hem_living_expense;
}

function get_preliminary_assessment_documents(state) {
  return state.preliminary_assessment_documents;
}

function system_messages(state) {
  return state.system_messages;
}

export default{
    application,
    allTypesAgents,
    auction,
    application_id,
    application_status,
    getApplication,
    work_basket,
    auction_basket,
    mql_auction_basket,
    distribution_basket,
    auction_lead_basket,
    application_search,
    options,
    properties,
    docTemplates,
    documentTypes,
    documentRequests,
    administration_permissions,
    administration_roles,
    administrationRolesMatrix,
    administrationUsers,
    administrationPods,
    user,
    userHasPermission,
    getAllApplicationsNextActionData,
    userHasRole,
    product_types,
    productApplicantTypes,
    productAssetTypes,
    productLenders,
    products,
    assessment,
    ml_assessment,
    veda_report,
    auditLogs,
    administrationBillings,
    administrationBrokers,
    ppsrSearchResults,
    ppsrFetchResults,
    getPpsrVinValue,
    getPpsrRegistrationValue,
    getPpsrStatus,
    getBillings,
    warranty_billings,
    application_update_status_dialog,
    application_update_owners_dialog,
    application_comment_dialog,
    application_quick_response_dialog,
    employment_directorship_dialog,
    edit_user_profile_dialog,
    application_referrer,
    uploadedDocuments,
    landTitleFetchResults,
    administrationIntroducers,
    administrationGlassPrices,
    administrationAdjustments,
    makers,
    all_makers,
    models,
    models_make,
    glasses,
    uploadedDocumentsWithoutBankStatement,
    uploadedDocsWithTypeOther,
    uploadedDocumentsBankStatement,
    generatedDocuments,
    signedDocuments,
    security,
    getSelectedBills,
    advance_search_application,
    reportingMetaDataAppBased,
    reportingMetaDataSettlementBased,
    preGraphData,
    lenders_breakdown,
    toggleSubmitToLenderForm,
    activeAppsGraphData,
    deletedDocuments,
    error_fields,
    administrationAgents,
    introducers,
    appLockConfig,
    applicationLocks,
    current_lock,
    is_editing,
    userHasAppPermission,
    getApplicationNextActionData,
    is_ram_authorized,
    broker_postcode,
    broker_radius,
    agent_has_visibility_subscription,
    cut_off_day,
    userHasAnyRole,
    call_outcome_logs,
    get_auction_notification,
    get_last_auction_notification_timestamp,
    leadRequests,
    isPodManager,
    pagination,
    get_hem_living_expense_access,
    get_hem_living_expense,
    getLeadRequestsForecasts,
    system_messages,
    get_preliminary_assessment_documents,
    requires_current_privacy_consent,
    requires_previous_privacy_consent,
    show_live_auction_drawer,
    live_auction_previews,
    veda_summary_dialog,
    updating_application,
    selected_pipeline_columns
}
